import { CheckForUpdate } from "./check-for-update.service";
import { LogUpdate } from "./log-update.service";
import { PromptUpdate } from "./prompt-update.service";
import { Log } from "./log.service";
import { Push } from "./push.service";
import { Seo } from "./seo.service";

export default {
  CheckForUpdate,
  PromptUpdate,
  LogUpdate,
  Log,
  Push,
  Seo,
};

export const SERVICES = [
  CheckForUpdate,
  PromptUpdate,
  LogUpdate,
  Log,
  Push,
  Seo,
];
